import moment from 'moment';
import { getPersonnelDetail, personnelDetailReduction } from '../../customerManage/request';
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object
    }
  },
  watch: {
    async visible(newV) {
      if (newV) {
        this.reset();
        await this.getInfo();
      }
      this.showVisible = newV;
    }
  },
  computed: {
    showDate() {
      return moment(this.form.startAt).format('YYYY/MM/DD') + ' ' + this.$t('至') + ' ' + moment(this.form.endAt).format('YYYY/MM/DD') + ' ';
    },
    showPrice() {
      // 退保天数：保险止期-责任止期
      let _end1 = moment(this.form.endAt1).format('YYYY-MM-DD');
      let _end = moment(this.form.endAt).format('YYYY-MM-DD');
      let end1Res = moment(_end1 + ' 00:00:00').isSame(moment(this.form.endAt1));
      let endRes = moment(_end + ' 00:00:00').isSame(moment(this.form.endAt1));
      let days = (end1Res ? moment(this.form.endAt1) : moment(this.form.endAt1).add(1, 'days')).diff(endRes ? this.form.endAt : moment(this.form.endAt).add(1, 'days'), 'day');
      let price = Math.round(this.form.price / this.yearDays * days * 100) / 100;
      return price;
    }
  },
  data() {
    return {
      form: {},
      rules: {},
      loading: false,
      showVisible: false,
      isSame: false,
      yearDays: 365
    };
  },
  methods: {
    onChangeTime() {
      if (this.form.endAt) {
        let _result = this.isSameTime();
        this.isSame = _result;
        if (_result) {
          this.form.endAt = this.form.endAt1;
        } else {
          this.form.endAt = moment(this.form.endAt).format('YYYY-MM-DD');
        }
      }
    },
    disabledDate(current) {
      let res = moment(this.form.startAt).diff(moment().subtract(1, 'months').subtract(1, 'day'), 'days');
      if (res < 0) {
        return current && current > moment().endOf('day') || current && current < moment().subtract(1, 'months').subtract(1, 'day');
      } else {
        return current && current > moment().endOf('day') || current && current < moment(this.form.startAt);
      }
    },
    async saveReduce() {
      if (!this.form.endAt) {
        return this.$message.warn(this.$t('请选择') + this.$t('责任止期'));
      }
      this.loading = true;
      let obj = {
        endAt: this.form.endAt,
        rePremium: this.showPrice,
        personnelDetailsId: this.params.personnelDetailsId,
        policyId: this.params.policyId
      };
      if (!this.isSame) {
        obj.endAt += ' 23:59:59';
      }
      await personnelDetailReduction(obj);
      this.$message.success(this.$t('操作成功'));
      this.loading = false;
      this.$emit('ok');
    },
    async getInfo() {
      const res = await getPersonnelDetail(this.params);
      this.form.name = res.insuredInfo.name;
      this.form.idNumber = res.insuredInfo.idNumber;
      this.form.startAt = res.insuredInfo.startAt; // 责任起期
      this.form.price = res.insuranceInfo.premium; //保费
      this.form.endAt1 = res.insuranceInfo.endAt; // 保险止期
      this.form.declarationMethod = res.insuranceInfo.declarationMethod;
      if (res.insuranceInfo.declarationMethod == 'DAY') {
        let _result = this.isSameTime();
        this.isSame = _result;
        if (_result) {
          this.form.endAt = this.form.endAt1;
        } else {
          this.form.endAt = moment().format('YYYY-MM-DD');
        }
      } else {
        // this.form.endAt = undefined;
      }
      if (res.insuranceInfo.rate && res.insuranceInfo.rate === 'day') {
        //费率类型为日费率的时候保费除的时候除366
        this.yearDays = 366;
      }
    },
    // 责任止期和保险止期是否相同
    isSameTime() {
      return moment(this.form.endAt).isSame(moment(this.form.endAt1), 'day');
    },
    reset() {
      // this.form.endAt = undefined;
      // this.form.endAt1 = undefined;
      // this.form.startAt = undefined;
      // this.form.idNumber = '';
      // this.form.name = '';
      this.form = {};
      this.isSame = false;
    }
  }
};